import { makeStyles } from "@material-ui/core/styles";
export const useStyles = makeStyles(() => ({
  container: {
    padding: 20,
    paddingTop: 100,
    paddingLeft: 15,
  },
  galleryContainer: {
    margin: '0 auto'
  },
  imageItem: {
    marginBottom: 15,
    paddingRight: 10,
    paddingLeft: 10
  },
  modalBody: {
    top: '50%',
    position: 'absolute',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    padding: '15px',
    backgroundColor: 'white',
    border: 0
  },
  imageContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
}));